import React, { useEffect, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import { stateArray } from "../../utilities/stateJson";
import api from "../../seller-apis/api";
import { useAlert } from "react-alert";

function ManageAddress(props) {
  const [address, setAddress] = useState("");
  const [landmark, setLandMark] = useState("");
  const [zip, setZip] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [sameAddress, setsameAddress] = useState(false);

  const [pAddress, setPAddress] = useState("");
  const [pLandmark, setPLandMark] = useState("");
  const [pZip, setPZip] = useState("");
  const [pCity, setPCity] = useState("");
  const [pState, setPState] = useState("");
  const [error, setError] = useState(false);
  const alert=useAlert();
  useEffect(() => {
    if (sameAddress) {
      setPAddress(address);
      setPLandMark(landmark);
      setPZip(zip);
      setPCity(city);
      setPState(state);
    } else {
      setPAddress("");
      setPLandMark("");
      setPZip("");
      setPCity("");
      setPState("");
    }
  }, [sameAddress]);
  const saveStep2Data = () => {
    let gadres = {
      city: city,
      state: state,
      landmark: landmark,
      zipcode: zip,
      address: address,
    };
    let registrationdata = {
      _id: props.vendorId,
      gAddress: gadres,
      city: pCity,
      state: pState,
      address: pAddress,
      zipcode: pZip,
      landmark: pLandmark,
      "sendStepsCompleteMail":true,
      profileStepsCompleted: [
        ...props.profile.profileStepsCompleted,
        {
          name: "step2",
          value: true,
        },
      ],
    };
    api.seller
      .updateInfo(registrationdata)
      .then((res) => {
        props.changeStep("step3");
        props.updateResponseData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Card>
      <div className="theme-shed1 p-2 bank-account address">
        <div className="title theme-shed1 p-2">Add GST Address</div>
        <div className="details-container">
          <div className="theme-shed1 w-60 mb-2">
            <input
              type="text"
              name="phone"
              className="profile-input"
              id="phone"
              onChange={(e) => {
                setAddress(e.target.value);
                sameAddress && setPAddress(e.target.value);
              }}
              placeholder="Address* (Street, Apartment, Area Near, etc.)"
              value={address}
            />
            {error && address == "" ? (
              <div className="validation-error">Address is required</div>
            ) : (
              ""
            )}
          </div>
          <div className="grid-50 w-60 mb-2">
            <div className="theme-shed1">
              <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="Landmark"
                onChange={(e) => {
                  setLandMark(e.target.value);
                  sameAddress && setPLandMark(e.target.value);
                }}
                value={landmark}
              />
            </div>
            <div className="theme-shed1">
              <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="Zip/Postal Code*"
                onChange={(e) =>{
                  setZip((v) => (e.target.validity.valid ? e.target.value : v));
                  sameAddress&&setPZip((v) => (e.target.validity.valid ? e.target.value : v))
                }}
                pattern="[0-9]*"
                maxLength={6}
                value={zip}
              />
              {error && zip == "" ? (
                <div className="validation-error">Pincode is required</div>
              ) : (
                ""
              )}
              {error && zip != "" && zip.length != 6 ? (
                <div className="validation-error">
                  Pincode must be 6 digit long
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="grid-50 w-60 mb-2">
            <div className="theme-shed1">
              <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="City*"
                onChange={(e) => {
                  setCity(e.target.value)
                  sameAddress&&setPCity(e.target.value)
                }}
                value={city}
              />
              {error && city == "" ? (
                <div className="validation-error">City is required</div>
              ) : (
                ""
              )}
            </div>
            <div className="theme-shed1">
              <select
                name="state"
                className="profile-input"
                value={state}
                onChange={(e) => {
                  setState(e.target.value);
                  sameAddress&&setPState(e.target.value);
                }}
              >
                <option>Select State</option>
                {stateArray.map((state, i) => {
                  return (
                    <option value={state} key={i}>
                      {state}
                    </option>
                  );
                })}
                ;
              </select>
              {error && state == "" ? (
                <div className="validation-error">State is required</div>
              ) : (
                ""
              )}
              {/* <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="Select State*"
                onChange={(e) =>setState(e.target.value)}
                value={state}
              /> */}
            </div>
          </div>
        </div>
      </div>

      <div className="theme-shed1 p-2 bank-account address">
        <div className="title theme-shed1 p-2">Add Pickup Address</div>
        <div className="dis-flex p-2">
          <input
            type="checkbox"
            value={sameAddress}
            checked={sameAddress}
            id="sameaddress"
            onChange={() => setsameAddress(!sameAddress)}
          />{" "}
          <span class="main-color" for="sameaddress">
            Same as GST Address{" "}
          </span>
        </div>
        <div className="details-container">
          <div className="theme-shed1 w-60 mb-2">
            <input
              type="text"
              name="phone"
              className="profile-input"
              id="phone"
              onChange={(e) => setPAddress(e.target.value)}
              placeholder="Address* (Street, Apartment, Area Near, etc.)"
              value={pAddress}
            />
            {error && pAddress == "" ? (
              <div className="validation-error">Address is required</div>
            ) : (
              ""
            )}
          </div>
          <div className="grid-50 w-60 mb-2">
            <div className="theme-shed1">
              <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="Landmark"
                onChange={(e) => setPLandMark(e.target.value)}
                value={pLandmark}
              />
            </div>
            <div className="theme-shed1">
              <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="Zip/Postal Code*"
                onChange={(e) =>
                  setPZip((v) => (e.target.validity.valid ? e.target.value : v))
                }
                pattern="[0-9]*"
                maxLength={6}
                value={pZip}
              />
              {error && pZip == "" ? (
                <div className="validation-error">Pincode is required</div>
              ) : (
                ""
              )}
              {error && pZip != "" && pZip.length < 6 ? (
                <div className="validation-error">
                  Pincode must be 6 digit long
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="grid-50 w-60 mb-2">
            <div className="theme-shed1">
              <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="City*"
                onChange={(e) => setPCity(e.target.value)}
                value={pCity}
              />
              {error && pCity == "" ? (
                <div className="validation-error">City is required</div>
              ) : (
                ""
              )}
            </div>
            <div className="theme-shed1">
              <select
                name="city"
                className="profile-input"
                value={pState}
                onChange={(e) => setPState(e.target.value)}
              >
                <option>Select State</option>
                {stateArray.map((state, i) => {
                  return (
                    <option value={state} key={i}>
                      {state}
                    </option>
                  );
                })}
                ;
              </select>
              {error && pState == "" ? (
                <div className="validation-error">City is required</div>
              ) : (
                ""
              )}
              {/* <input
                type="text"
                name="phone"
                className="profile-input"
                id="phone"
                placeholder="Select State*"
                onChange={(e) =>setPState(e.target.value)}
                value={pState}
              /> */}
            </div>
          </div>
        </div>
        {/* {props?.profile && props?.profile?.emailVerified? */}
        <div className="text-center w-60 my-3">
          {!city ||
          !state ||
          !address ||
          !zip ||
          zip.length != 6 ||
          !pCity ||
          !pState ||
          !pAddress ||
          pZip.length != 6 ||
          !pZip ? (
            <button
              className="profile-submit profile-submit-disable"
              onClick={() => setError(true)}
            >
              Submit & Next
            </button>
          ) : (
            
            <button className="profile-submit" onClick={() => saveStep2Data()}>
              Submit & Next
            </button>
          )}
        </div>
        {/*:
        <div className="text-center w-60 my-3">
          <button className="button-style" onClick={()=>alert.info("Verify your email to proceed further")}>Submit & Next</button>
          </div>
          }*/}
      </div>
    </Card>
  );
}

export default ManageAddress;
